import { apiV1, shareApi } from 'app/services/api';

export const authApi = apiV1.injectEndpoints({
  endpoints: (build) => ({
    login: build.mutation<
      { token: string; refreshToken: string },
      {
        email: string;
        password: string;
      }
    >({
      query: (credential: { email: string; password: string }) => ({
        url: `micro/auth/inspector/admin/login`,
        method: 'POST',
        body: credential
      }),
      transformResponse: (baseQueryReturnValue) => {
        return {
          token: '',
          refreshToken: '',
          ...(baseQueryReturnValue as any).data
        };
      }
    })
  })
});

export const meApi = shareApi.injectEndpoints({
  endpoints: (build) => ({
    me: build.query({
      query: () => ({
        url: `${process.env.REACT_APP_API_V1_VERSION}/user/me`,
        method: 'GET'
      }),
      transformResponse: (baseQueryReturnValue) => {
        return {
          data: (baseQueryReturnValue as any).data[0]
        };
      }
    })
  })
});

export const userApi = shareApi.injectEndpoints({
  endpoints: (build) => ({
    resetPassword: build.mutation({
      query: (params) => ({
        url: `${process.env.REACT_APP_API_V1_VERSION}/auth/resetPassword`,
        method: 'POST',
        body: params
      })
    })
  })
});

export const { useLoginMutation } = authApi;
export const { useMeQuery } = meApi;
export const { useResetPasswordMutation } = userApi;
